import { http } from '../../config/axios'

export default function patchFaturaIncobravelService(id: string): Promise<string> {
  return http
    .patch('/api/fatura/incobravel/' + id)
    .then((r) => r.data)
    .catch((error) => {
      console.error('Erro ao marcar fatura como incobrável', error)
      throw Error(error.response?.data)
    })
}
